import * as server from '../entries/pages/_page.server.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.js";
export const imports = ["_app/immutable/nodes/2.BmY6dqUN.js","_app/immutable/chunks/KZK0-soZ.js","_app/immutable/chunks/BZTNq1Um.js","_app/immutable/chunks/2mOfPPFS.js","_app/immutable/chunks/DW-TuIxf.js","_app/immutable/chunks/BGfRHZdV.js","_app/immutable/chunks/CW0xTaoG.js","_app/immutable/chunks/kwBiegc5.js"];
export const stylesheets = [];
export const fonts = [];
